import React from 'react';
import styled from 'styled-components';
import TaskScheduler from '../components/TaskScheduler';
import Alert from '../components/Alert';
import Loading from '../components/Loading';
import { useTask } from '../context/TaskContext';
import { useZone } from '../context/ZoneContext';

const TasksContainer = styled.div`
  padding: 1.5rem;
`;

const PageTitle = styled.h1`
  margin: 0 0 1.5rem 0;
  font-size: ${({ theme }) => theme.typography.sizes.xl};
  color: ${({ theme }) => theme.colors.text.primary};
`;

const TasksPage = () => {
  const { state, addTask, deleteTask, completeTask, updateTask } = useTask();
  const { filteredTasks, tasks, loading, error, notification } = state;
  const { state: zoneState } = useZone();
  const { zones } = zoneState;



  // Handle task completion
  const handleTaskComplete = async (taskId) => {
    await completeTask(taskId);
  };

  // Handle task deletion
  const handleTaskDelete = async (taskId) => {
    await deleteTask(taskId);
  };

  // Handle adding a new task
  const handleTaskAdd = async (taskData) => {
    await addTask({
      ...taskData,
      createdBy: 'user',
      assignedTo: 'user'
    });
  };

  // Handle editing a task
  const handleTaskEdit = async (taskId, taskData) => {
    await updateTask(taskId, {
      ...taskData,
      updatedAt: new Date().toISOString()
    });
  };

  return (
    <TasksContainer>
      <PageTitle>Task Management</PageTitle>
      
      {error && <Alert type="error" message={error} dismissible />}
      {notification && (
        <Alert 
          type={notification.type} 
          message={notification.message} 
          dismissible 
        />
      )}
      
      {loading && <Loading />}
      
      <TaskScheduler 
        tasks={filteredTasks.length > 0 ? filteredTasks : tasks || []}
        zones={zones}
        onTaskComplete={handleTaskComplete}
        onTaskDelete={handleTaskDelete}
        onTaskAdd={handleTaskAdd}
        onTaskEdit={handleTaskEdit}
        loading={loading}
        error={error}
      />
    </TasksContainer>
  );
};

export default TasksPage;
